import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from '~/base/BaseServices.module.scss';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

// const DigitalTransformation = ({ t }) => {
const ErpDeployment = () => {
    const { t } = useTranslation();
    let { pathname } = useLocation();

    const data = {
        title: t('Optimize every aspect of'),
        indexClass: 4,
        titleTech: t('We offer comprehensive ERP solutions'),
        video: '/videos/services/video_erp.mp4',
        titleContent: t('ERP Implementation'),
        poster: '/videos/services/erp.png',
        content: t('We implement the best ERP system'),
    };
    const detailServices = [
        {
            label: t('Finance - Accounting'),
            description: t('(General Ledger, AP/AR, Budgeting)'),
            image: require('../../assets/images/services/erp-deployment/finance-accounting.png'),
        },
        {
            label: t('Sales & CRM'),
            description: t('(Order Management, Invoicing, Customer Management)'),
            image: require('../../assets/images/services/erp-deployment/sales-crm.png'),
        },
        {
            label: t('Procurement & Supply Chain'),
            description: t('(Purchasing, Inventory, Supplier Management)'),
            image: require('../../assets/images/services/erp-deployment/procurement-supply-chain.png'),
        },
        {
            label: t('Manufacturing'),
            description: t('(Production Planning, BOM, Quality Control)'),
            image: require('../../assets/images/services/erp-deployment/manufacturing.png'),
        },
        {
            label: t('Human Resources & Payroll'),
            description: t('(HRM, Payroll, Recruitment)'),
            image: require('../../assets/images/services/erp-deployment/human-resources-payroll.png'),
        },
        {
            label: t('Reporting & Analytics'),
            description: t('(BI, Dashboards, KPI Tracking)'),
            image: require('../../assets/images/services/erp-deployment/reporting-analytics.png'),
        },
    ]
    const ctaData = {
        title: t('Tight and flexible business processes'),
        description: t('Odyssey optimizes business processes with industry-leading experience from experts in the field. Real-world assessments provide flexible to handle variables.'),
    }
    const partnerList = [
        { name: 'Odoo', logo: require('../../assets/images/services/erp-deployment/partner-1.png') },
        { name: 'NetSuite', logo: require('../../assets/images/services/erp-deployment/partner-2.png') },
        { name: 'SAP', logo: require('../../assets/images/services/erp-deployment/partner-3.png') },
        { name: 'Microsoft Dynamics 365', logo: require('../../assets/images/services/erp-deployment/partner-4.png') },
    ];

    return (
        <div className={cx('solution')}>
            <div className={cx('solution__intro')}>
                <div
                    className={cx('solution__intro-wraper')}
                    style={{
                        position: 'absolute',
                        maxWidth: '900px',
                        left: '110px',
                        top: '26px',
                    }}
                >
                    <div className={cx('solution__intro__title')}>{data.title}</div>
                    <div className={cx('solution__intro__description')}>{data.titleTech}</div>
                </div>
            </div>

            <div className={cx('solution__new', 'solution__new-service-' + data.indexClass)}>
                <div className={cx('solution__new__top')}>
                    <div className={cx('solution__new__top__content')}>{data.titleContent}</div>
                    <div className={cx('solution__new__top__content-two')}>
                        <p>{data.content}</p>
                    </div>
                </div>
                <div>
                    {window.innerWidth > 768 ? (
                        <video
                            crossOrigin="anonymous"
                            playSinline="true"
                            preload="auto"
                            loop
                            tabIndex="-1"
                            autoPlay
                            muted
                            src={data.video}
                            className="desktop-video"
                            style={{ width: '800px', maxWidth: '100%' }}
                        ></video>
                    ) : (
                        <img style={{ width: '100%' }} src={data.poster} alt="Mobile Image" />
                    )}
                </div>
            </div>
            {/* Services Grid Section */}
            <div className={cx("solution__services", "solution__services__" + pathname.split('/')[1])}>
                <div className={cx("solution__services__title")}>
                    {t("Don't let your business fall behind in the digital era 4.0")}
                </div>

                <div className={cx("solution__services__description")}>
                    {t("Our ERP implementation provides the power to optimize and effectively utilize the available resources from within your business and complete it into a closed process.")}
                </div>

                <div className={cx("solution__services__grid")}>
                    {detailServices.map((service, index) => (
                        <div className={cx("solution__services__item")}>
                            <div className={cx("solution__services__item__image")}>
                                <img src={service.image} alt={service.label} />
                            </div>
                            <div className={cx("solution__services__item__content")}>
                                <div className={cx("solution__services__item__content__text")}>
                                    <h3>{service.label}</h3>
                                    <p>{service.description}</p>
                                </div>
                                <div className={cx("solution__services__item__content__arrow")}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Call to Action Section */}
            <div style={{ backgroundColor: '#141416' }}>
                <div className={cx("solution__cta__2")}>
                    <div className={cx("solution__cta__2__content", "solution__cta__2__content__" + pathname.split('/')[1])}>
                        <div className={cx("solution__cta__2__text")}>
                            <h2>{ctaData.title}</h2>
                            <p>{ctaData.description}</p>
                        </div>
                        <Link to="/contact" className={cx("solution__cta__button")}>
                            {t("CONTACT US >")}
                        </Link>
                        {/* <div className={cx("solution__cta__image")}></div> */}
                    </div>
                </div>

            </div>

            {/* System image */}
            <div className={cx("solution__system-image")}>
                <img src={require('../../assets/images/services/erp-deployment/system-hero-img.png')} alt="System" />
            </div>

            {/* Process Section */}
            <div className={cx("solution__process")}>
                <div className={cx("solution__process__header")}>
                    <h2 className={cx("solution__process__title")}>{t("We implement a process that is closely aligned")}</h2>
                    <p className={cx("solution__process__subtitle")}>
                        {t("Our 6-phases process will improve the quality of management and digitization of your business")}
                    </p>
                </div>

                <div className={cx("solution__process__grid")}>
                    <div className={cx("solution__process__item")}>
                        <div className={cx("solution__process__item__number")}>01</div>
                        <div className={cx("solution__process__item__content")}>
                            <h3>{t("Preparation & Needs Assessment")}</h3>
                            <ul>
                                <li>{t("Define objectives (e.g., optimize inventory, accelerate sales).")}</li>
                                <li>{t("Evaluate current processes and identify gaps.")}</li>
                                <li>{t("Form a project team (IT, executives, end-users).")}</li>
                            </ul>
                        </div>
                        <div className={cx("solution__process__item__decoration")}></div>
                    </div>

                    <div className={cx("solution__process__item")}>
                        <div className={cx("solution__process__item__number")}>02</div>
                        <div className={cx("solution__process__item__content")}>
                            <h3>{t("ERP Solution Selection")}</h3>
                            <ul>
                                <li>{t("On-Premise ERP: High control, large upfront investment.")}</li>
                                <li>{t("Cloud ERP (SaaS): Flexible, subscription-based.")}</li>
                                <li>{t("Hybrid ERP: Combination of both.")}</li>
                            </ul>
                        </div>
                        <div className={cx("solution__process__item__decoration")}></div>
                    </div>

                    <div className={cx("solution__process__item")}>
                        <div className={cx("solution__process__item__number")}>03</div>
                        <div className={cx("solution__process__item__content")}>
                            <h3>{t("Analysis & Design")}</h3>
                            <ul>
                                <li>{t("Map business processes to the ERP system.")}</li>
                                <li>{t("Customize (if needed) or adapt processes to ERP best practices.")}</li>
                            </ul>
                        </div>
                        <div className={cx("solution__process__item__decoration")}></div>
                    </div>

                    <div className={cx("solution__process__item")}>
                        <div className={cx("solution__process__item__number")}>04</div>
                        <div className={cx("solution__process__item__content")}>
                            <h3>{t("Deployment & Configuration")}</h3>
                            <ul>
                                <li>{t("Import master data (products, customers, suppliers).")}</li>
                                <li>{t("Configure workflows, user permissions.")}</li>
                                <li>{t("Conduct testing (Unit Test → Integration Test → UAT).")}</li>
                            </ul>
                        </div>
                        <div className={cx("solution__process__item__decoration")}></div>
                    </div>

                    <div className={cx("solution__process__item")}>
                        <div className={cx("solution__process__item__number")}>05</div>
                        <div className={cx("solution__process__item__content")}>
                            <h3>{t("Training & Transition")}</h3>
                            <ul>
                                <li>{t("Train end-users (managers, employees).")}</li>
                                <li>{t("Run parallel testing (if needed) for accuracy.")}</li>
                                <li>{t("Go-live (full system adoption).")}</li>
                            </ul>
                        </div>
                        <div className={cx("solution__process__item__decoration")}></div>
                    </div>

                    <div className={cx("solution__process__item")}>
                        <div className={cx("solution__process__item__number")}>06</div>
                        <div className={cx("solution__process__item__content")}>
                            <h3>{t("Maintenance & Optimization")}</h3>
                            <ul>
                                <li>{t("Monitor issues, provide post-implementation support.")}</li>
                                <li>{t("Upgrade versions, expand features.")}</li>
                            </ul>
                        </div>
                        <div className={cx("solution__process__item__decoration")}></div>
                    </div>
                </div>
            </div>

            {/* Partners Section */}
            <div className={cx("solution__partners")}>
                <div className={cx("solution__partners__content")}>
                    <div className={cx("solution__partners__grid")}>
                        {partnerList.map((partner, index) => (
                            <div className={cx("solution__partners__item")}>
                                <img src={partner.logo} alt={partner.name} className={cx("solution__partners__logo")} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErpDeployment
